// puzzleProgress.js — çözülen bulmacaları tarayıcıda (localStorage) hatırlar.
const KEY = 'sogi_solved_puzzles';

export function getSolved() {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) || '[]'));
  } catch {
    return new Set();
  }
}

export function markSolved(id) {
  try {
    const s = getSolved();
    s.add(id);
    localStorage.setItem(KEY, JSON.stringify([...s]));
  } catch {
    // depolama kapalıysa yok say
  }
}
